// extracted by mini-css-extract-plugin
module.exports = {"name":"_2i2kEXjUdSwUY1zK0NvvWD","duration":"_3qED9zMs3diGZVX9cHQ5gM","capacity":"_2Gyg4ep0uQD-wFJw6ExfRs","pricing":"_1YBhPIGq3n25HMdkG3J-EM"};